import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {CustomerPartial, ICollarPartial, PetPartial, RequestError} from 'shared';
import * as Highcharts from 'highcharts';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatTableDataSource} from "@angular/material/table";
import {groupBy} from 'extensions/array';

@Component({
  selector: 'app-device-errors-detail',
  templateUrl: './device-errors-detail.component.html',
  styleUrls: ['./device-errors-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DeviceErrorsDetailComponent {

  linesHighcharts: typeof Highcharts = Highcharts;

  columns = ['pet', 'flash_error', 'battery_connection_error', 'imu_error'];

  dataSource: MatTableDataSource<CollarErrors>;

  // linesChartOptions: Highcharts.Options = {
  linesChartOptions: any = {
    chart: {
      animation: {
        duration: 500
      },
      marginRight: 50
    },
    title: {
      text: ''
    },
    legend: {
      enabled: false
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      opposite: true,
      tickPixelInterval: 150,
      title: {
        text: null
      }
    },
    plotOptions: {
      series: {
        animation: false,
        groupPadding: 0,
        pointPadding: 0.1,
        borderWidth: 0,
        colorByPoint: true,
        dataSorting: {
          enabled: true,
          matchByName: true
        },
        type: 'bar',
        dataLabels: {
          enabled: true
        }
      }
    },
    series: [
      {
        type: 'bar',
        name: 'Errors',
        data: []
      }
    ],
    responsive: {
      rules: [{
        condition: {
          maxWidth: 550
        },
        chartOptions: {
          xAxis: {
            visible: false
          },
          subtitle: {
            x: 0
          },
          plotOptions: {
            series: {
              dataLabels: [{
                enabled: true,
                y: 8
              }, {
                enabled: true,
                format: '{point.name}',
                y: -8,
                style: {
                  fontWeight: 'normal',
                  opacity: 0.7
                }
              }]
            }
          }
        }
      }]
    }
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: RequestError[]) {
    this.linesChartOptions.title.text = this.data[0].timestamp.format('MMM DD');

    let flash_errors = this.data.filter(i => i.flash_error).length;
    let battery_connection_errors = this.data.filter(i => i.battery_connection_error).length;
    let imu_errors = this.data.filter(i => i.imu_error).length;

    this.linesChartOptions.series[0].data.push(['Flash', flash_errors]);
    this.linesChartOptions.series[0].data.push(['Battery', battery_connection_errors]);
    this.linesChartOptions.series[0].data.push(['IMU', imu_errors]);

    const errors: CollarErrors[] = [];
    groupBy(this.data, item => item.collar, (first, second) => first.id == second.id).forEach((items, collar) => {
      const flash_error = items.find(i => i.flash_error);
      const battery_connection_error = items.find(i => i.battery_connection_error);
      const imu_error = items.find(i => i.imu_error);

      errors.push({
        ...collar,
        pet: items[0].pet,
        owner: items[0].owner,
        flash_error: flash_error ? {id: flash_error.id, timestamp: flash_error.timestamp} : undefined,
        battery_connection_error: battery_connection_error ? {id: battery_connection_error.id, timestamp: battery_connection_error.timestamp} : undefined,
        imu_error: imu_error ? {id: imu_error.id, timestamp: imu_error.timestamp} : undefined,
      });
    });

    this.dataSource = new MatTableDataSource<CollarErrors>(errors);
  }
}

interface CollarErrors extends ICollarPartial {
  pet: PetPartial,
  owner: CustomerPartial,
  flash_error?: CollarError
  battery_connection_error?: CollarError
  imu_error?: CollarError
}

interface CollarError {
  id: string
  timestamp: moment.Moment
}
